<template>
  <v-layout row wrap class="custom-group reserve-price-layout form-section-gap" no-gutters>
    <v-flex xs12 md5 class="pr-md-4">
      <v-layout
        no-gutters
        class="custom-group reserve-price-field form-field"
        column
        justify-center
        align-start
      >
        <div class="reserve-price-toggle">
          <input
            id="enable-reserve-price"
            type="checkbox"
            :checked="enabled"
            @change="onToggle"
          />
          <label for="enable-reserve-price" class="placeholder mb-0">Enable reserve price</label>
        </div>
        <template v-if="enabled">
          <span class="placeholder">Reserve price:</span>
          <input
            class="custom-input reserve-price-input"
            type="number"
            :value="reservePrice"
            placeholder="0"
            @input="onInput"
          />
          <span v-if="errReservePrice" class="error-input reserve-price-error"
            >Use a positive number</span
          >
          <span class="reserve-price-hint">
            The desired price level for this deal. If set, the summary will show if the target was met.
          </span>
        </template>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'AuctionFormReservePrice',
  props: {
    enabled: { type: Boolean, default: false },
    reservePrice: { type: Number, required: true },
    errReservePrice: { type: Boolean, default: false },
  },
  methods: {
    onToggle(e) {
      this.$emit('update:enabled', e.target.checked);
    },
    onInput(e) {
      const v = e.target.value === '' ? 0 : Number(e.target.value);
      this.$emit('update:reservePrice', Number.isFinite(v) ? v : 0);
    },
  },
};
</script>

<style scoped>
.reserve-price-layout {
  margin-top: 6px;
}

.reserve-price-field {
  margin-bottom: 8px;
}

.reserve-price-toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.reserve-price-toggle input,
.reserve-price-toggle label {
  cursor: pointer;
}

.reserve-price-toggle label {
  color: #216169;
  font-size: 12px;
  font-weight: 500;
}

.reserve-price-input {
  max-width: 180px;
}

.reserve-price-hint {
  margin-top: 4px;
  font-size: 11px;
  font-weight: 500;
  color: #216169;
  text-align: left;
}

.reserve-price-error {
  margin-top: 2px;
  margin-bottom: 2px;
}
</style>
